import { ActionTypes } from '../constants';

const defaults = {
  venueMode: false,
};

export interface CacheState {
  /*  */
  venueMode: Boolean,
}

export interface ActionType {
  type: string;
  payload: any;
}

export default (state: CacheState = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.UPDATE_DEVICE_API_DATA: {
      return { ...state, ...action.payload };
    }
    default:
      return { ...state };
  }
};
